<template>
  <div class="card">
    <div class="card__header">
      <BasePoster
        v-if="id"
        :name="id"
        :alt="title"
        :is-round="false"
        format="png"
        class="card__image"
      />
      <div v-if="title" class="card__name">
        <BaseTitle v-html="title" is-medium size="s" class="card__title" />
      </div>
    </div>
    <div class="card__content">
      <BaseText v-if="text" v-html="text" size="xs" class="card__text" />
      <slot />
    </div>
    <div v-if="link" class="card__footer">
      <BaseButton is-border text="Читать полностью" :href="link" size="s">
        Скачать приложение
        <BaseIcon name="arrow_right" class="button__icon button__icon_after" />
      </BaseButton>
    </div>
    <BaseLink v-if="href" :href="href" class="card__link" />
  </div>
</template>

<script>
import { PLATFORM } from '@/App.vue';

import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';
import BasePoster from '@/components/BasePoster.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';
import BaseLink from '@/components/BaseLink.vue';

export default {
  name: 'BaseCard',
  components: {
    BaseTitle,
    BaseText,
    BasePoster,
    BaseButton,
    BaseIcon,
    BaseLink,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
    links: {
      type: Object,
      default: null,
    },
  },
  computed: {
    link() {
      if (!this.links) return '';
      if (['OS X', 'iOS'].includes(PLATFORM) && this.links.ios) {
        return this.links.ios;
      }
      // if (['Android'].includes(PLATFORM) && this.links.android) {
      //   return this.links.android;
      // }
      return this.links.android || this.links.site || '';
    },
  },
};
</script>

<style lang="stylus">
.card
  position relative
  display block
  background #fff
  padding 1em
  box-shadow 0 0.25em 1em rgba(0, 0, 0, 0.07)
  border-radius 1em
  +landscape()
    display flex
    flex-direction column
    padding 1.3em
  &__header
    display flex
    align-items center
  &__image
    flex 0 0 6em
    max-width 66px
    border 0
  &__name
    flex-grow 1
    flex-basis 0
    max-width 100%
    ^[0]__image ~ &
      max-width calc(100% - 66px)
      padding-left 1em
  &__title
    color #000
  &__text
    color #696969
  &__content
    margin-top 0.5em
  &__footer
    padding-top 1em
    +landscape()
      margin-top auto
  &__link
    abs top left right bottom
    display block
    z-index 1
</style>
